var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/weight"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M10.0347 13.2972H5.34028C4.52674 13.2972 3.8716 13.0273 3.42057 12.5763C2.96955 12.1253 2.69965 11.4701 2.69965 10.6566V4.78852C2.69965 3.97499 2.96955 3.31984 3.42057 2.86882C3.8716 2.41779 4.52674 2.14789 5.34028 2.14789H10.0347C10.8483 2.14789 11.5034 2.41779 11.9544 2.86882C12.4054 3.31984 12.6753 3.97499 12.6753 4.78852V10.6566C12.6753 11.4701 12.4054 12.1253 11.9544 12.5763C11.5034 13.0273 10.8483 13.2972 10.0347 13.2972Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.586806
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.70698 5.55449C6.42067 4.07164 8.96283 4.06991 10.6728 5.5478L9.46941 7.47988C8.43722 6.62008 6.93841 6.62008 5.90622 7.47988L4.70698 5.55449Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.586806
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.a351835a85b9092725eaaff3e45c2d13.svg";
export { ForwardRef as ReactComponent };